import script from "./InstructionKeyCrmPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionKeyCrmPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionKeyCrmPage.vue?vue&type=style&index=0&id=4e96ea31&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e96ea31"]])

export default __exports__